import React, { StrictMode } from 'react';
import ReactDOM from 'react-dom';

import { theme, ThemeProvider } from './styles/styled';
import GlobalStyle from './styles/global';
import App from './App';

ReactDOM.render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <App />
    </ThemeProvider>
  </StrictMode>,
  document.getElementById('root'),
);
